<template>
  <v-app id="inspire">
    <PublicHeader />
    <div :style="{ paddingTop: '60px', height: '100%' }">
      <router-view />
    </div>
    <PublicFooter />
  </v-app>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import PublicHeader from "@/components/PublicLayout/PublicHeader";
import PublicFooter from "@/components/PublicLayout/PublicFooter";
import "./styles/public-layout.scss";

@Component({ components: { PublicHeader, PublicFooter } })
export default class PublicLayout extends Vue {}
</script>

<style lang="stylus" scoped>
font = 'Poppins', sans-serif;

a {
  text-decoration: none;
}

.header-title {
  font-family: font;
  font-size: 1.6rem;
  font-weight: 600;
}
</style>
